module.exports = __webpack_public_path__ + "static/img/2.d43493f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/hsyl/hjzz/2.png
// module id = r2Rm
// module chunks = 1